import React from 'react'
import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'

import ClientAndPatient from '~/components/common/ClientAndPatient'
import type { Prescription } from '~/types'

import styles from './SwapProductDetails.module.scss'

export interface SwapProductDialogDetailsProps {
  prescription: Prescription
}

const SwapProductDetails = ({
  prescription,
}: SwapProductDialogDetailsProps) => {
  const { t } = useTranslation('Dialogs')

  return (
    <KibContainer className={styles.mainContainer}>
      <div className={styles.innerContainer}>
        <div className={styles.title}>
          {t('SWAP_PRODUCT_DIALOG.REQUESTED_RX_TITLE')}
        </div>
        <div className={styles.content}>{prescription.name}</div>
      </div>
      <div className={styles.innerContainer}>
        <div className={styles.title}>
          {t('SWAP_PRODUCT_DIALOG.PATIENT_SELECTED_TITLE')}
        </div>
        <ClientAndPatient
          loadClient
          clientId={prescription.clientId}
          patientId={prescription.patientId}
          textVariant="body2"
        />
      </div>
    </KibContainer>
  )
}

export default SwapProductDetails
